import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all language files
import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import pl from './locales/pl.json';
import ro from './locales/ro.json';
import tr from './locales/tr.json';
import uk from './locales/uk.json';
import ru from './locales/ru.json';
import bg from './locales/bg.json';
import hr from './locales/hr.json';
import cs from './locales/cs.json';
import sk from './locales/sk.json';
import hu from './locales/hu.json';
import pt from './locales/pt.json';
import es from './locales/es.json';
import it from './locales/it.json';
import sq from './locales/sq.json';
import ar from './locales/ar.json';
import zh from './locales/zh.json';
import nl from './locales/nl.json';

const resources = {
  de: { translation: de },
  en: { translation: en },
  fr: { translation: fr },
  pl: { translation: pl },
  ro: { translation: ro },
  tr: { translation: tr },
  uk: { translation: uk },
  ru: { translation: ru },
  bg: { translation: bg },
  hr: { translation: hr },
  cs: { translation: cs },
  sk: { translation: sk },
  hu: { translation: hu },
  pt: { translation: pt },
  es: { translation: es },
  it: { translation: it },
  sq: { translation: sq },
  ar: { translation: ar },
  zh: { translation: zh },
  nl: { translation: nl }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['de', 'en', 'fr', 'pl', 'ro', 'tr', 'uk', 'ru', 'bg', 'hr', 'cs', 'sk', 'hu', 'pt', 'es', 'it', 'sq', 'ar', 'zh', 'nl'],
    load: 'languageOnly', // This will convert "de-DE" to "de"
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'userLanguage',
      caches: ['localStorage']
    }
  });

// Helper to change language based on user profile
export const setLanguageFromUser = (user) => {
  if (user?.language) {
    i18n.changeLanguage(user.language);
    localStorage.setItem('userLanguage', user.language);
  }
};

export default i18n;
